import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { tlf3000 } from "@/data/content";

const Tlf3000 = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["8%", "-8%"]);

  return (
    <section
      id="tlf-3000"
      ref={ref}
      className="relative overflow-hidden bg-fw-navy py-24 md:py-32 text-white"
      data-testid="tlf3000-section"
    >
      {/* Spotlight */}
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-[70vh] w-[70vh] -translate-x-1/2 rounded-full bg-fw-red/25 blur-[120px]" />

      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <Reveal>
              <span className="inline-block rounded-full bg-fw-red px-4 py-1.5 font-technical uppercase tracking-widest text-xs">
                {tlf3000.badge}
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-technical font-black uppercase text-6xl md:text-8xl leading-[0.85] text-white">
                {tlf3000.title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-2 font-heritage italic text-2xl text-fw-gold">{tlf3000.subtitle}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-5 max-w-md font-body text-white/70">{tlf3000.intro}</p>
            </Reveal>

            <motion.div style={{ y: imgY }} className="mt-10 lg:hidden">
              <img src={tlf3000.image} alt={tlf3000.title} className="w-full object-contain drop-shadow-2xl" />
            </motion.div>

            <div className="mt-10 grid grid-cols-2 gap-px bg-white/10 border border-white/10" data-testid="tlf3000-specs">
              {tlf3000.specs.map((s, i) => (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.05 }}
                  className={`bg-fw-navy p-4 ${i === tlf3000.specs.length - 1 && tlf3000.specs.length % 2 === 1 ? "col-span-2" : ""}`}
                >
                  <p className="font-technical uppercase tracking-wider text-[11px] text-fw-gold">{s.label}</p>
                  <p className="mt-1 font-body text-white text-sm md:text-base">{s.value}</p>
                </motion.div>
              ))}
            </div>
          </div>

          <motion.div style={{ y: imgY }} className="hidden lg:block">
            <img src={tlf3000.image} alt={tlf3000.title} className="w-full object-contain drop-shadow-2xl" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Tlf3000;
